import { render, staticRenderFns } from "./NavFormalities.vue?vue&type=template&id=044f3fe5&"
import script from "./NavFormalities.vue?vue&type=script&lang=js&"
export * from "./NavFormalities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports